import { useEffect, useRef } from 'react';

type Config = {
  /** если true стартует интервал */
  when: boolean;
  /** вызывать ли callback функцию перед стартом интервала */
  startImmediate: boolean;
  /** время интервала */
  interval: number;
  /** дата окончания таймера */
  endTime: Date;
};

export const useInterval = (
  callback: () => void,
  { interval, when, startImmediate, endTime }: Config,
) => {
  const timerRef = useRef<ReturnType<typeof setInterval> | undefined>();

  useEffect(() => {
    if (!when) {
      timerRef.current = undefined;
      return () => undefined;
    }
    if (startImmediate) {
      callback();
    }
    const timer: ReturnType<typeof setInterval> = setInterval(() => {
      callback();
    }, interval);
    timerRef.current = timer;

    return () => {
      clearInterval(timer);
      timerRef.current = undefined;
    };
  }, [when, endTime]);

  return { timerId: timerRef.current };
};
